import React from 'react';
import { HeaderListDownloadDataStyled } from './styles';

export interface Props {
  children: React.ReactNode;
}

export default function HeaderListDownloadData({ children }: Props) {
  return (
    <HeaderListDownloadDataStyled>{children}</HeaderListDownloadDataStyled>
  );
}
